import IllustrationImage from "../../../assets/images/projects/blibli-illustration/thumbnail.png";
import { ProjectDataProps } from "../props";

export default {
  title: "Others: Illustrations",
  description: "Few illustrations I made for Blibli",
  image: IllustrationImage,
  path: "/blibli-illustration",
} as ProjectDataProps;
